import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var PushPinIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 12 16" }),
        React.createElement("path", { d: "M9.20003 5.6V1.6H10C10.44 1.6 10.8 1.24 10.8 0.8C10.8 0.36 10.44 0 10 0H2.00002C1.56002 0 1.20002 0.36 1.20002 0.8C1.20002 1.24 1.56002 1.6 2.00002 1.6H2.80002V5.6C2.80002 6.928 1.72802 8 0.400024 8V9.6H5.17602V15.2L5.97603 16L6.77603 15.2V9.6H11.6V8C10.272 8 9.20003 6.928 9.20003 5.6Z" })));
};

export { PushPinIcon };
//# sourceMappingURL=PushPinIcon.esm.js.map
